import { Input } from '../Input';

type InputOnChange = NonNullable<Parameters<typeof Input>[0]['onChange']>;
export type PercentProps = Omit<Parameters<typeof Input>[0], 'type' | 'suffix' | 'onChange' | 'value'> & {
  value: number | null;
  onChange: (val: number | null, event: Parameters<InputOnChange>[1]) => ReturnType<InputOnChange>;
  onFocus?: Parameters<typeof Input>[0]['onFocus'];
  suffix?: Parameters<typeof Input>[0]['suffix'];
};

const makeValidNumber = (str: string | undefined | null): number | null => {
  if (str === undefined || str === null || str === '') {
    return null;
  }

  const asNumber = +str;
  if (Number.isNaN(asNumber)) {
    return null;
  }

  return asNumber;
};

const makeString = (value: number | null): string => {
  if (value === null || value === undefined || Number.isNaN(value)) {
    return '';
  }
  return `${value}`;
};

const NumberInput: React.FC<PercentProps> = ({ onChange, value, ...props }) => {
  const handleChange: Parameters<typeof Input>[0]['onChange'] = (val, event) => {
    onChange(makeValidNumber(val), event);
  };
  return <Input {...props} value={makeString(value)} type="number" onChange={handleChange} />;
};

export default NumberInput;
